import React from 'react';

import { useMutation } from '@apollo/client';
import { faSpinner } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

import opportunityAssigmentRequest from '../../../services/opportunityAssigment/gqlSchema';

const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiTextField-root': {
      width: '100%',
    },
  },
}));

const TextFieldComment = ({ opportunityAssignment }) => {
  const classes = useStyles();
  const [comment, setComment] = React.useState(opportunityAssignment.leadComment || '');

  const [updateComment, { loading, error }] = useMutation(opportunityAssigmentRequest.Mutation.setStatutLead, {
    variables: {
      opportunityAssignmentId: opportunityAssignment.id,
      statutLead: { leadComment: comment },
    },
  });

  if (error) {
    console.error(error);
  }

  const handleChange = event => {
    if (event.target.value.length < 2500) {
      setComment(event.target.value);
    }
  };

  const handleOnBlur = async () => {
    await updateComment();
  };

  return (
    <form className={classes.root} noValidate autoComplete='off'>
      <div style={{ position: 'relative', width: '100%', height: '100%' }}>
        {loading && (
          <FontAwesomeIcon
            style={{ width: '1rem', marginRight: '0.5rem', position: 'absolute', bottom: '4px', right: '1px' }}
            icon={faSpinner}
            spin={true}
          />
        )}
        <TextField
          id='outlined-multiline-static'
          label='Commentaire'
          multiline
          rows={4}
          value={comment}
          onChange={event => handleChange(event)}
          variant='outlined'
          onBlur={() => handleOnBlur()}
        />
      </div>
    </form>
  );
};

export default TextFieldComment;
